<template>
  <div v-if="current">
    <v-row>
      <v-col cols="12" sm="4">
        <v-alert dense text type="info">
          {{ current.length }} registros encontrados
        </v-alert>
      </v-col>
      <v-col cols="12" sm="2">
        <v-btn color="primary" @click="register()" block>+</v-btn>
      </v-col>
    </v-row>
    <v-simple-table>
      <thead>
        <tr>
          <th>Nome</th>
          <th>Descrição</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in current" :key="item.id">
          <td>{{ item.name }}</td>
          <td>{{ item.description }}</td>
          <td><v-btn icon @click="edit(item.id)"><v-icon>mdi-magnify</v-icon></v-btn></td>
        </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>
import api from "../../api/index.js";
import router from "../../router/index.js";
export default {
  data: function () {
    return {
      current: null,
    };
  },
  created: function () {
    this.list();
  },
  methods: {
    register: function () {
      router.push({ path: `/contact_type/0` });
    },
    list: function () {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/contact_type", {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.current = response.data;
        })
        .catch(function (error) {
          console.log(error);
          alert("Falha ao listar registros!");
        });
    },
    edit: function (id) {
      router.push({ path: `/contact_type/${id}` });
    },
    colorRole: function (status) {
      var ret = "default";
      if (status == 1) {
        ret = "success";
      } else if (status == 2) {
        ret = "primary";
      }
      return ret;
    },
  },
  filters: {
    formatRole: function (value) {
      var ret = "desconhecido";
      if (value == 1) {
        ret = "Administrador";
      } else if (value == 2) {
        ret = "Usuario";
      }
      return ret;
    },
  },
};
</script>